// // Mobile navigation toggle button function
// $(".header .navbar-toggler").on("click", function () {
//   if ($("body").hasClass("mobile-nav-open")) {
//     // hide mobile nav
//     $(".site-navigation").toggleClass("site-navigation-open");
//     $("body").toggleClass("mobile-nav-open");
//     $(".header").toggleClass("mobile-nav-open");
    
//     setTimeout(function() {
//       $("header").toggleClass("mobile-nav-open-z-index");
//     }, 360); // sum of transition duration and a bit more for class removing proccessing
//   } else {
//     // display mobile nav
//     $("header").toggleClass("mobile-nav-open-z-index");

//     setTimeout(function() {
//       $(".site-navigation").toggleClass("site-navigation-open");
//       $("body").toggleClass("mobile-nav-open");
//       $(".header").toggleClass("mobile-nav-open");
//     }, 60);
//   }
// });

// // Adding class on scroll for colored header
// var heroHeight = 70;
// // if ($(".iva-section.homepage-hero").length) {
// //   heroHeight = $(".iva-section.homepage-hero").height();
// //   heroHeight = heroHeight / 2;
// // }
// function iva_header_classes_on_load_and_scroll() {
//   if ($('header').hasClass('transparent-header')) {
//     var scroll = $(window).scrollTop();
//     if (scroll >= heroHeight) {
//       $(".header").addClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').removeClass('btn-light');
//     } else {
//       $(".header").removeClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').addClass('btn-light');
//     }
//   }
// }

// $(window).on("scroll", function () {
//   if ($('header').hasClass('transparent-header')) {
//     iva_header_classes_on_load_and_scroll();
//   }
// });
// $(window).on("load", function() {
//   setTimeout(() => {
//     iva_header_classes_on_load_and_scroll();
//   }, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  const navbarToggler = document.querySelector('.header .navbar-toggler');
  const body = document.body;
  const header = document.querySelector('.header');
  const siteNav = document.querySelector('.site-navigation');

  if (navbarToggler && header && siteNav) {
    navbarToggler.addEventListener('click', function () {
      if (body.classList.contains('mobile-nav-open')) {
        siteNav.classList.toggle('site-navigation-open');
        body.classList.toggle('mobile-nav-open');
        header.classList.toggle('mobile-nav-open');
        setTimeout(function () {
          document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        }, 360);
      } else {
        document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        setTimeout(function () {
          siteNav.classList.toggle('site-navigation-open');
          body.classList.toggle('mobile-nav-open');
          header.classList.toggle('mobile-nav-open');
        }, 60);
      }
    });
  }

  const heroHeight = 70;
  const mainHeader = document.querySelector('header');
  const scrollBtn = document.querySelector('.header .navbar-btn-wrap .btn.d-llg-flex');

  function iva_header_classes_on_load_and_scroll() {
    if (mainHeader && mainHeader.classList.contains('transparent-header')) {
      const scroll = window.scrollY;
      if (scroll >= heroHeight) {
        mainHeader.classList.add('header-scrolled');
        // scrollBtn?.classList.remove('btn-light');
      } else {
        mainHeader.classList.remove('header-scrolled');
        // scrollBtn?.classList.add('btn-light');
      }
    }
  }

  window.addEventListener('scroll', iva_header_classes_on_load_and_scroll);

  window.addEventListener('load', function () {
    setTimeout(iva_header_classes_on_load_and_scroll, 500);
  });
});

// Tooltip na mobitelu - toggle na klik
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.btn.disabled');

    // Zatvori sve otvorene tooltipe
    document.querySelectorAll('.btn.disabled.tooltip-visible').forEach(el => {
        if (el !== btn) el.classList.remove('tooltip-visible');
    });

    if (btn && btn.querySelector('.iva-btn-tooltip')) {
        e.preventDefault();
        btn.classList.toggle('tooltip-visible');
    }
});

// $.fn.isInViewport = function () {
//     let elementTop = $(this).offset().top;
//     let elementBottom = elementTop + $(this).outerHeight();
//     let viewportTop = $(window).scrollTop();
//     let viewportBottom = viewportTop + $(window).height();
//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// $(window).on("load resize scroll", function () {
//     $('.animateOnEnter').each(function() {
//         if ( $(this).isInViewport() ) {
//             $(this).addClass('inView');
//         }
//     });
// });



// document.addEventListener("DOMContentLoaded", () => {
//   const elems = document.querySelectorAll('.animate-on-scroll');
//   if (!('IntersectionObserver' in window)) {
//     // fallback: prikaži odmah
//     elems.forEach(el => el.classList.add('in-view'));
//     return;
//   }

//   const io = new IntersectionObserver((entries) => {
//     entries.forEach(({ target, isIntersecting }) => {
//       if (isIntersecting) {
//         target.classList.add('in-view');
//         io.unobserve(target);  // animiraj samo jednom
//       }
//     });
//   }, {
//     rootMargin: '0px 0px -15% 0px', // pokreće malo ranije
//     threshold: 0
//   });

//   elems.forEach(el => io.observe(el));
// });



// document.addEventListener("DOMContentLoaded", () => {
//   const sections = document.querySelectorAll('.iva-section');

//   if (!('IntersectionObserver' in window)) {
//     document.querySelectorAll('.animate-on-scroll')
//       .forEach(el => el.classList.add('in-view'));
//     return;
//   }

//   const io = new IntersectionObserver((entries) => {
//     entries.forEach(({ target, isIntersecting }) => {
//       if (!isIntersecting) return;

//       const children = target.querySelectorAll('.animate-on-scroll');

//       children.forEach((el, i) => {
//         // osnovni stagger (120ms po elementu)
//         const base = i * 120;

//         // random varijacija od -40ms do +40ms
//         const random = Math.floor(Math.random() * 80) - 40;

//         const delay = Math.max(0, base + random); // nikad ispod 0

//         el.style.transitionDelay = `${delay}ms`;
//         el.classList.add('in-view');
//       });

//       io.unobserve(target);
//     });
//   }, {
//     rootMargin: '0px 0px -15% 0px',
//     threshold: 0
//   });

//   sections.forEach(section => io.observe(section));
// });






// document.addEventListener("DOMContentLoaded", () => {
//   const sections = document.querySelectorAll('.iva-section');

//   if (!('IntersectionObserver' in window)) {
//     document.querySelectorAll('.animate-on-scroll')
//       .forEach(el => el.classList.add('in-view'));
//     return;
//   }

//   const io = new IntersectionObserver((entries) => {
//     entries.forEach(({ target, isIntersecting }) => {
//       if (!isIntersecting) return;

//       const children = target.querySelectorAll('.animate-on-scroll');

//       children.forEach((el, i) => {
//         const base = i * 120;
//         const random = Math.floor(Math.random() * 80) - 40;
//         const delay = Math.max(0, base + random);

//         el.style.transitionDelay = `${delay}ms`;
//         el.classList.add('in-view');

//         // Kad animacija završi → očisti sve tragove
//         el.addEventListener('transitionend', () => {
//           el.style.transitionDelay = '';
//           el.classList.remove('animate-on-scroll');
//           el.classList.remove('in-view');
//         }, { once: true });
//       });

//       io.unobserve(target);
//     });
//   }, {
//     rootMargin: '0px 0px -15% 0px',
//     threshold: 0
//   });

//   sections.forEach(section => io.observe(section));
// });












document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll('.iva-section');

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.animate-on-scroll')
      .forEach(el => el.classList.add('in-view'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;

      const children = target.querySelectorAll('.animate-on-scroll');
      const count = children.length;

      // maksimalno ukupno trajanje staggera
      const maxTotal = 1000; // 1 sekunda

      children.forEach((el, i) => {
        // dinamički stagger koji se prilagođava broju elemenata
        const base = (maxTotal / count) * i;

        // random varijacija ±30ms (manja da ne razbije ritam)
        const random = Math.floor(Math.random() * 60) - 30;

        const delay = Math.max(0, base + random);

        el.style.transitionDelay = `${delay}ms`;
        el.classList.add('in-view');

        el.addEventListener('transitionend', () => {
          el.style.transitionDelay = '';
          el.classList.remove('animate-on-scroll');
          el.classList.remove('in-view');
        }, { once: true });
      });

      io.unobserve(target);
    });
  }, {
    rootMargin: '0px 0px -15% 0px',
    threshold: 0
  });

  sections.forEach(section => io.observe(section));
});


document.addEventListener("DOMContentLoaded", () => {
  const elems = document.querySelectorAll('.animate-on-scroll--no-section');
  if (!('IntersectionObserver' in window)) {
    // fallback: prikaži odmah
    elems.forEach(el => el.classList.add('in-view--no-section'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        setTimeout(() => {
			target.classList.add('in-view--no-section');
		}, 500);
        io.unobserve(target);  // animiraj samo jednom
      }
    });
  }, {
    rootMargin: '0px 0px -15% 0px', // pokreće malo ranije
    threshold: 0
  });

  elems.forEach(el => io.observe(el));
});
// $('[data-toggle="scroll-to"]').click(function() {

//   var $this = $(this);

//   if ( $this.data('scroll-offset') == true ) {
//     var offset = $('.header').height();
//   } else {
//     var offset = 0;
//   }

//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       $('html, body').animate({
//         scrollTop: target.offset().top - offset
//       }, 1000);
//       return false;
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-toggle="scroll-to"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const useOffset = link.dataset.scrollOffset === 'true';
      const offset = useOffset ? (document.querySelector('.header')?.offsetHeight || 0) : 0;

      const currentPath = location.pathname.replace(/^\//, '');
      const targetPath = link.pathname.replace(/^\//, '');
      const isSamePage = currentPath === targetPath && location.hostname === link.hostname;

      if (isSamePage) {
        let target = document.querySelector(link.hash);
        if (!target) {
          target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
        }

        if (target) {
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});

// $(document).ready(function() {
// 	$("#skipper").click(function() {
// 		$('#mainContent').attr('tabIndex', -1).focus();
// 	})
// });
document.addEventListener('DOMContentLoaded', function () {
  const skipper = document.getElementById('skipper');
  const mainContent = document.getElementById('mainContent');

  if (skipper && mainContent) {
    skipper.addEventListener('click', function () {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
    });
  }
});

// $(document).ready(function() {
// 	var width   = 981;
// 	var height  = 461;
// 	var left    = (screen.width / 2) - (width / 2);
// 	var top     = (screen.height / 2) - (height / 2);
// 	$('.js-share-link').click(function(e) {
// 		e.preventDefault();
// 		window.open(
// 		$(this).attr('href'),
// 		'',
// 		'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
// 		);
// 	});
// });
document.addEventListener('DOMContentLoaded', function () {
  const width = 981;
  const height = 461;
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  const shareLinks = document.querySelectorAll('.js-share-link');

  shareLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(
        link.getAttribute('href'),
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,' +
        'width=' + width + ',height=' + height +
        ',top=' + top + ',left=' + left
      );
    });
  });
});
